import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../api/auth/AuthContext';

const ProtectedRoute: React.FC = () => {
  const { authType, ssoChecking } = useAuth();

  if (ssoChecking) {
    return <div className="protected-route-loading">Verificando acceso...</div>;
  }

  if (authType !== 'internal') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
